import React from "react";
import { PageShell } from "./PageShell";
import { PageIntro } from "../components/PageIntro";
import { About } from "../components/sections/About";

export default function AboutPage() {
  return (
    <PageShell>
      <div className="pt-[72px]">
        <PageIntro contentKey="about" />
        <About hideIntro />
      </div>
    </PageShell>
  );
}
